import { useCallback, use } from "react";
import { useI18n } from "./i18n-hooks";
import { useMutation } from "@apollo/client/react";
import { DELETE_USER } from "../graphql/identity";
import { useSnackbar } from "./snackbar";
import { FirebaseManagerContext } from "../contexts/FirebaseManager";
import { useSetAlert } from "./use-set-alert";

export const useDeleteAccount = () => {
    const i18n = useI18n();
    const [deleteUser] = useMutation(DELETE_USER);
    const { showSnackbar } = useSnackbar();
    const { signOut } = use(FirebaseManagerContext);
    const { setAlert } = useSetAlert();

    const onDeleteAccount = useCallback(() => {
        setAlert({
            title: i18n.t("profile.delete_account_title"),
            message: i18n.t("profile.delete_account_description"),
            buttons: [
                {
                    text: i18n.t("profile.delete_account_confirm"),
                    onPress: () => {
                        const asyncFunc = async () => {
                            const deleteResult = await deleteUser();
                            if (deleteResult.data?.deleteUser) {
                                showSnackbar({
                                    text: i18n.t("profile.delete_account_success"),
                                    mode: "success",
                                });
                                void signOut();
                            } else {
                                setAlert({
                                    title: i18n.t("profile.delete_account_error"),
                                    message: i18n.t("profile.delete_account_error_description"),
                                    buttons: [
                                        {
                                            text: i18n.t("ok"),
                                            style: "default",
                                        },
                                    ],
                                });
                            }
                        };
                        void asyncFunc();
                    },
                    style: "destructive",
                },
                {
                    text: i18n.t("cancel"),
                    style: "cancel",
                },
            ],
            options: { cancelable: true },
        });
    }, [setAlert, i18n, deleteUser, showSnackbar, signOut]);

    return onDeleteAccount;
};
